/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';

// Local Definitions

import "./styles.scss";
const baseClassName = styleNames.base;
const componentClassName = 'description';

/**
 * This is the component description.
 */
const Description = ({
  id,
  className: userClassName,
  style,
  description,
  name,
  color
  // ...otherProps
}) => {
  const [, meta] = useField(name);
  const hasError = meta.touched && meta.error;
  if (hasError || description) {
    return /*#__PURE__*/React.createElement("div", {
      id: id,
      className: [baseClassName, componentClassName, userClassName, hasError ? 'x-error' : `x-${color}`].filter(e => e).join(' '),
      style: style
    }, hasError ? meta.error : description);
  }
  return null;
};
Description.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The base color for the description
   */
  color: PropTypes.string,
  /**
   * Input description - extra description to guide a use in filling the input
   */
  description: PropTypes.string,
  /**
   * The input name (html - and Formik state)
   */
  name: PropTypes.string.isRequired
};
Description.defaultProps = {
  color: 'metadata'
};
export default Description;